// Sverige
export default {
	status: {
		All: "Alla",
		Pending: "Väntande",
		Frozen: "Frusen",
		Completed: "Slutförd",
		Undone: "Ej utförd"
	},
	TotalAmount: "Totalbelopp",
	Profit: "Vinst",
	Expire: "Förfalla"
};
